import { ArrowUpOutlined } from '@ant-design/icons';

import SortIcon from '@/assets/icons/SortIcon';
import { Flex } from '@/components/base';
import Transition from '@/components/Common/Transition';
import useColor from '@/hooks/domain/useColor';

type OrdererProps = {
  orderable?: boolean;
  orderStatus?: OrderStatusT;
  nextOrder: () => void;
};

const Orderer = (props: OrdererProps) => {
  const color = useColor();
  if (!props.orderable) return null;

  return (
    <Transition
      status={props.orderStatus !== 'unset'}
      fallback={
        <Flex onClick={props.nextOrder} style={{ cursor: 'pointer' }}>
          <SortIcon color={color.gray500} />
        </Flex>
      }
    >
      <ArrowUpOutlined
        alt="Ascending"
        style={{
          fontSize: 16,
          color: color.gray500,
          rotate: props.orderStatus === 'asc' ? '180deg' : '0deg',
          transition: 'all 0.2s',
        }}
        onClick={props.nextOrder}
      />
    </Transition>
  );
};

export default Orderer;
